function cart(
    state = {
        cancelled_payment: false,
        payment_error: false,
        show_empty_checkout_items: false,
        invalid_transaction: false,
        shipment_location_details: {
          origin: 6,
          destination: "PH"
        }
    }, 
    action)
    {
        switch (action.type) {
            case 'SHOW_CANCELLED_PAYMENT_MESSAGE':{
                return{
                    ...state,
                    cancelled_payment:true,
                }
            }
            case 'SHOW_ERROR_ON_PAYMENT_MESSAGE':{
                return {
                    ...state,
                    payment_error:true,
                }
            }
            case 'SHOW_EMPTY_CHECKOUT_MESSAGE':{
                return {
                    ...state,
                    show_empty_checkout_items:true,
                }
            }
            case 'SHOW_INVALID_TRANSACTION_ERROR': {
              return {
                ...state,
                invalid_transaction: true,
              }
            }
            case 'CLEAR_CART_MESSAGES':{
                return {
                    ...state,
                    cancelled_payment: false,
                    payment_error: false,
                    show_empty_checkout_items: false,
                    invalid_transaction: false,
                }
            }
            case 'UPDATE_SHIPMENT_LOCATION_DETAILS': {
              return {
                ...state,
                shipment_location_details: {
                  ...state.shipment_location_details,
                    origin: action.origin,
                    destination: action.destination
                }
              }
            }
            default: break
        }

        return state;
    }
  export default cart;
  


/** WEBPACK FOOTER **
 ** ./src/reducers/cart.js
 **/